import { InsertLinksHost } from 'owa-attachment-link-common';
import { Ribbon, RibbonProps } from 'owa-editor-ribbonplugin';
import * as React from 'react';
import { tryGetButtonsWithFilePicker } from '../utils/tryGetButtonsWithFilePicker';

export interface ComposeRibbonProps extends RibbonProps {
    insertLinksHost: InsertLinksHost;
    fromAddress: string;
    upsellClickHandler: () => void;
}
export const ComposeRibbon = function (composeRibbonProps: ComposeRibbonProps) {
    return (
        <Ribbon
            buttons={tryGetButtonsWithFilePicker(
                composeRibbonProps.insertLinksHost,
                composeRibbonProps.fromAddress,
                composeRibbonProps.upsellClickHandler
            )}
            {...composeRibbonProps}
        />
    );
};
